import React from "react";
import {
  Table,
  TableRow,
  TableCell,
  TableHeader,
} from "carbon-react/lib/components/table";
import Spinner from "carbon-react/lib/components/loader";
import UserStatusPill from "./UserStatusPill";
import UserPopOverContextMenu from "./UserPopOverContextMenu";
import UserEmailVerifiedPill from "./UserEmailVerifiedPill";
import SimpleTablePager from "../common/simpleTablePager/SimpleTablePager";

const UserTable = ({
  userResultSet,
  loading,
  onUpdateUser,
  openCommentsDialog,
  openChangeEmailDialog,
  openVerifyEmailAccessDialog,
  openResetPasswordDialog,
  openDeleteUserDialog,
  openBypassEmailVerificationDialog,
  openBypassMfaDialog,
  onPagePrev,
  onPageNext,
}) => {
  const userResults = userResultSet;
  const users = userResults.users || [];
  const tableRows = users.map((user, key) => {
    return (
      <TableRow id={`users-table-row-${key}`} key={user.userId}>
        <TableCell id={`users-table-cell-name-${key}`}>{user.name}</TableCell>
        <TableCell id={`users-table-cell-email-${key}`}>{user.email}</TableCell>
        <TableCell id={`users-table-cell-user-id-${key}`}>
          {user.userId}
        </TableCell>
        <TableCell id={`users-table-cell-legacy-id-${key}`}>
          {user.sageId}
        </TableCell>
        <TableCell id={`users-table-cell-status-${key}`}>
          <UserStatusPill user={user} />
        </TableCell>
        <TableCell id={`users-table-cell-email-verified-${key}`}>
          <UserEmailVerifiedPill user={user} />
        </TableCell>
        <TableCell id={`users-table-cell-actions-${key}`}>
          <UserPopOverContextMenu
            user={user}
            onUpdateUser={onUpdateUser}
            openCommentsDialog={openCommentsDialog}
            openChangeEmailDialog={openChangeEmailDialog}
            openVerifyEmailAccessDialog={openVerifyEmailAccessDialog}
            openResetPasswordDialog={openResetPasswordDialog}
            openDeleteUserDialog={openDeleteUserDialog}
            openBypassEmailVerificationDialog={
              openBypassEmailVerificationDialog
            }
            openBypassMfaDialog={
              openBypassMfaDialog
            }
          />
        </TableCell>
      </TableRow>
    );
  });

  const tableHeader = (
    <TableRow>
      <TableHeader id="users-table-header-name">Name</TableHeader>
      <TableHeader id="users-table-header-email">Email address</TableHeader>
      <TableHeader id="users-table-header-auth0-id">Auth0 ID</TableHeader>
      <TableHeader id="users-table-header-legacy-id">Legacy ID</TableHeader>
      <TableHeader id="users-table-header-status">Status</TableHeader>
      <TableHeader id="users-table-header-email-verified">
        Email address verified
      </TableHeader>
      <TableHeader></TableHeader>
    </TableRow>
  );

  const gridSpinner = (
    <TableRow
      key="__loading__"
      selectable={false}
      highlightable={false}
      hideMultiSelect
    >
      <TableCell colSpan="100" align="center">
        <Spinner size="small" />
      </TableCell>
    </TableRow>
  );

  return (
    <div className="usersTable">
      <Table isZebra thead={tableHeader} shrink>
        {loading === true ? gridSpinner : tableRows}
      </Table>
      <SimpleTablePager
        appearBusy={loading}
        pageNo={userResultSet?.currentPage || 0}
        lastPage={userResultSet?.lastPage || 0}
        onPagePrev={onPagePrev}
        onPageNext={onPageNext}
      />
    </div>
  );
};

export default UserTable;
